import { redirectDocument } from "react-router-dom";

export const setUserDetails = (data) => {
  localStorage.setItem("user_Details", data);
}

export const getUserDetails = () => {
  return JSON.parse(localStorage.getItem("user_Details")) || null;
}

export const clearAllData = async () => {
  try {
    await localStorage.clear();
    console.log('All keys cleared from AsyncStorage');
  } catch (error) {
    console.error('Error clearing AsyncStorage:', error);
  }
};

export const setAsyncData = (key, data) => {
  localStorage.setItem(key, data);
}

export const getAsyncData = (key) => {
  try {
    const temp = localStorage.getItem(key);
    if (temp === null) return null;
    return JSON.parse(temp);
  } catch (error) {
    return localStorage.getItem(key);
  }
};

export const findRole = (role) => {
  if(role === "SUPER ADMIN"){
    return "ITL SUPER ADMIN"
  }
  else if(role === "SUB ADMIN"){
    return "ITL SUB ADMIN"
  }
  else if(role === "ADMIN"){
    return "CUSTOMER ADMIN"
  }
  else if(role === "REGIONAL ADMIN"){
    return "ITL REGIONAL ADMIN"
  }
  else if(role === "MACHINE INCHARGE"){
    return "CUSTOMER MACHINE INCHARGE"
  }
  else return
}
